function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { call, spawn } from 'redux-saga/effects';
import ApiService from 'services/ApiService';
import { NOTIFICATIONS_TRIGGERS } from 'modules/Notifications/constants';
function* sendNotification(notificationTrigger, notificationPayload) {
    const requestUrl = '/api/InstantNotification';
    yield call(ApiService.regionalRequest, requestUrl, {
        method: 'POST',
        body: _object_spread({
            notificationTrigger
        }, notificationPayload)
    });
}
function* sendClinicPatientProfileCreatedNotification({ clinicId, patientFirstName, patientLastName, localPatientProfileId } = {}) {
    yield spawn(sendNotification, NOTIFICATIONS_TRIGGERS.CLINIC_PATIENT_PROFILE_CREATED, {
        clinicId,
        patientFirstName,
        patientLastName,
        localPatientProfileId
    });
}
function* sendPatientProfileDeletedNotification({ clinicId, patientFirstName, patientLastName, leadHcpProfileId } = {}) {
    yield spawn(sendNotification, NOTIFICATIONS_TRIGGERS.PATIENT_PROFILE_DELETED, {
        clinicId,
        patientFirstName,
        patientLastName,
        leadHcpProfileId
    });
}
function* sendClinicPatientNewReadingsAddedNotification({ clinicId, hcpProfileId, patientFirstName, patientLastName, localPatientProfileId, readingsCount } = {}) {
    // @TODO: ClinicPatientProfileNewReadingsAdded
    yield spawn(sendNotification, NOTIFICATIONS_TRIGGERS.CLINIC_PATIENT_PROFILE_NEW_DATA_SYNCHRONIZED, {
        clinicId,
        hcpProfileId,
        patientFirstName,
        patientLastName,
        localPatientProfileId,
        readingsCount
    });
}
function* sendNoteWrittenByHcpNotification({ sharingRequestId } = {}) {
    yield spawn(sendNotification, NOTIFICATIONS_TRIGGERS.NOTE_WRITTEN_BY_HCP, {
        sharingRequestId
    });
}
function* sendNoteWrittenByPwdNotification({ clinicId, clinicName, patientFirstName, patientLastName, encryptedClinicPatientProfileId, sharingRequestId, hcpProfileId } = {}) {
    yield spawn(sendNotification, NOTIFICATIONS_TRIGGERS.NOTE_WRITTEN_BY_PWD, {
        clinicId,
        clinicName,
        patientFirstName,
        patientLastName,
        encryptedClinicPatientProfileId,
        sharingRequestId,
        hcpProfileId
    });
}
function* sendLeadHcpReassigned({ clinicId, leadHcpProfileId, patientFirstName, patientLastName, localPatientProfileId } = {}) {
    yield spawn(sendNotification, NOTIFICATIONS_TRIGGERS.LEAD_HCP_REASSIGNED, {
        clinicId,
        leadHcpProfileId,
        patientFirstName,
        patientLastName,
        localPatientProfileId
    });
}
export default {
    sendClinicPatientProfileCreatedNotification,
    sendPatientProfileDeletedNotification,
    sendClinicPatientNewReadingsAddedNotification,
    sendNoteWrittenByHcpNotification,
    sendNoteWrittenByPwdNotification,
    sendLeadHcpReassigned
};
